import { Link } from "react-router-dom";

export const Logo = ({ className = "" }) => (
  <Link to="/" data-testid="logo-link" aria-label="KLEDIO Startseite" className={`flex items-center shrink-0 mr-2 ${className}`}>
    <img
      src="/brand/kledio-logo.png"
      alt="KLEDIO"
      className="h-10 md:h-12 w-auto max-w-[120px] md:max-w-[150px] object-contain select-none"
      draggable="false"
    />
  </Link>
);
